/* KS cart drawer — compact foot helpers for third-party AIOD widgets.
 *
 * - Collapses the AIOD coupon input to a text toggle (mockup: 有折扣碼？點此輸入 ＋)
 * - Collapses order note widgets to the same text-toggle pattern
 * - Re-applies when AIOD reinjects widgets after cart refresh
 */
(function () {
  if (window.__ksCartDrawerCompact) return;
  window.__ksCartDrawerCompact = true;

  const COUPON_ENHANCED_ATTR = 'data-ks-aiod-coupon-enhanced';
  const COUPON_COLLAPSED_CLASS = 'ks-aiod-coupon-collapsed';
  const COUPON_TOGGLE_LABEL = '有折扣碼？點此輸入 ＋';

  const NOTE_ENHANCED_ATTR = 'data-ks-order-note-enhanced';
  const NOTE_COLLAPSED_CLASS = 'ks-order-note-collapsed';

  function getDrawerFoot() {
    return document.querySelector('.drawer--cart .drawer__foot');
  }

  function findCouponContainers(root) {
    if (!root) return [];

    const matches = Array.from(
      root.querySelectorAll('.aiod-widget-container-side-cart, .aiod-coupon-container')
    ).filter(function (node) {
      return node.querySelector('.aiod-coupon-input-group');
    });

    // AIOD nests .aiod-coupon-container inside .aiod-widget-container-side-cart.
    // Enhance the outer wrapper only so we don't render two toggles.
    return matches.filter(function (node) {
      return !matches.some(function (other) {
        return other !== node && other.contains(node);
      });
    });
  }

  function findOrderNoteWidgets(root) {
    if (!root) return [];
    return Array.from(root.querySelectorAll('[data-ks-order-note]'));
  }

  function placeOrderNoteNearCoupon(widget) {
    const foot = getDrawerFoot();
    if (!foot || !widget) return;

    const block = widget.closest('.ks-cart-order-note-block');
    if (!block) return;

    const buttonsAll = foot.querySelector('.cart__buttons-all');
    const coupon = foot.querySelector('.aiod-widget-container-side-cart');
    const footInner = foot.querySelector('.cart__foot__inner');

    if (!buttonsAll) return;

    // AIOD mounts the coupon inside .cart__buttons-all — stack coupon → note → CTA.
    if (coupon && coupon.parentNode === buttonsAll) {
      const anchor = coupon.nextElementSibling;
      if (block.parentNode !== buttonsAll || block !== anchor) {
        buttonsAll.insertBefore(block, anchor);
      }
      return;
    }

    if (coupon && coupon.parentNode) {
      if (block.parentNode !== coupon.parentNode || block.nextElementSibling !== coupon) {
        coupon.parentNode.insertBefore(block, coupon);
      }
      return;
    }

    if (footInner && footInner.contains(buttonsAll)) {
      if (block.parentNode !== footInner || block.nextElementSibling !== buttonsAll) {
        footInner.insertBefore(block, buttonsAll);
      }
    }
  }

  function openOrderNoteWidget(widget) {
    const collapsible = widget.closest('[data-collapsible]') || widget;
    const body = collapsible.querySelector('[data-collapsible-body]');
    const textarea = collapsible.querySelector('textarea[name="note"]');

    collapsible.classList.remove(NOTE_COLLAPSED_CLASS);
    collapsible.setAttribute('open', 'true');

    if (body) {
      body.style.height = 'auto';
    }

    if (textarea) {
      window.requestAnimationFrame(function () {
        textarea.focus();
      });
    }
  }

  function enhanceCoupon(container) {
    if (!container || container.hasAttribute(COUPON_ENHANCED_ATTR)) return;

    container.querySelectorAll('.ks-aiod-coupon-toggle').forEach(function (node) {
      node.remove();
    });

    container.setAttribute(COUPON_ENHANCED_ATTR, 'true');
    container.classList.add(COUPON_COLLAPSED_CLASS);

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ks-aiod-coupon-toggle';
    toggle.textContent = COUPON_TOGGLE_LABEL;

    toggle.addEventListener('click', function () {
      container.classList.remove(COUPON_COLLAPSED_CLASS);
      toggle.remove();

      const input = container.querySelector('.aiod-coupon-input');
      if (input) {
        window.requestAnimationFrame(function () {
          input.focus();
        });
      }
    });

    container.insertBefore(toggle, container.firstChild);
  }

  function enhanceOrderNote(widget) {
    if (!widget || widget.hasAttribute(NOTE_ENHANCED_ATTR)) return;

    const host = widget.closest('.ks-cart-order-note-block') || widget.parentElement;
    host?.querySelectorAll('.ks-order-note-toggle').forEach(function (node) {
      node.remove();
    });

    widget.setAttribute(NOTE_ENHANCED_ATTR, 'true');

    const textarea = widget.querySelector('textarea[name="note"]');
    const hasExistingNote = !!(textarea && textarea.value && textarea.value.trim());

    if (hasExistingNote) {
      openOrderNoteWidget(widget);
      placeOrderNoteNearCoupon(widget);
      return;
    }

    widget.classList.add(NOTE_COLLAPSED_CLASS);

    const toggleLabel = widget.getAttribute('data-toggle-label') || '有訂單備註？點此輸入 ＋';
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ks-order-note-toggle';
    toggle.textContent = toggleLabel;
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', function () {
      toggle.remove();
      openOrderNoteWidget(widget);
    });

    // Keep toggle outside <details> — buttons inside details collapse to 1px height.
    if (host) {
      host.insertBefore(toggle, widget);
    } else {
      widget.insertBefore(toggle, widget.firstChild);
    }
    placeOrderNoteNearCoupon(widget);
  }

  function scan() {
    const foot = getDrawerFoot();
    if (foot) {
      findCouponContainers(foot).forEach(enhanceCoupon);
      findOrderNoteWidgets(foot).forEach(function (widget) {
        if (widget.hasAttribute(NOTE_ENHANCED_ATTR)) {
          placeOrderNoteNearCoupon(widget);
          return;
        }
        enhanceOrderNote(widget);
      });
    }

    findOrderNoteWidgets(document.querySelector('.cart__aside')).forEach(function (widget) {
      if (widget.hasAttribute(NOTE_ENHANCED_ATTR)) {
        return;
      }
      enhanceOrderNote(widget);
    });
  }

  function scheduleScan() {
    window.clearTimeout(window.__ksCartDrawerCompactTimer);
    window.__ksCartDrawerCompactTimer = window.setTimeout(scan, 50);
  }

  function startObserver() {
    const foot = getDrawerFoot();
    if (foot) {
      const observer = new MutationObserver(scheduleScan);
      observer.observe(foot, { childList: true, subtree: true });
    }

    scan();
  }

  function bindEvents() {
    [
      'theme:cart:change',
      'theme:cart-drawer:open',
      'cart:refresh',
      'AIOD_WIDGET_CONTAINERS_INITIALIZED',
    ].forEach(function (name) {
      document.addEventListener(name, scheduleScan);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startObserver();
      bindEvents();
    });
  } else {
    startObserver();
    bindEvents();
  }
})();
